<script>
  import * as THREE from "three";
  import { range, max, rollup, shuffle, groups } from "d3";
  import { onMount, getContext } from "svelte";
  import { mode, loaded } from "../stores/global.js";
  import viewport from "../stores/viewport.js";
  import Planet from "./Universe.Planet.svelte";
  import spritesheet from "../data/spritesheet.csv";
  import slugify from "../utils/slugify.js";

  export let group;
  export let planetGroup = new THREE.Group();

  const { shows, categories } = getContext("App");
  const { DEPTH, NEAR, RADIUS } = getContext("Universe");

  const MAX_LAYER = 9;
  const IMAGES_PER_SPRITE = 16;
  let spreadX;
  let spreadY;
  let mounted;

  let textures = [];
  let planets = [];

  const layout = () => {
    const catLength = categories.length;
    const showLength = planets.length;
    const totalZ = DEPTH - NEAR;
    let startZ = -NEAR;
    const dupe = categories.map(({ name, count }) => ({
      name,
      count,
    }));
    dupe.reverse();

    let showIndex = 0;
    dupe.forEach(({ name, count }, k) => {
      const nodes = planets.filter((d) => d.level === name);
      const layers = max(nodes, (n) => n.layer) + 1;
      const catPercent = nodes.length / showLength;
      const chunkZ = catPercent * totalZ;

      nodes.forEach((n, i) => {
        const x = (i % 3) - 1 + (spreadX - Math.random() * spreadX * 2);
        const y = spreadY - Math.random() * spreadY * 2;
        const z = startZ + (i / count) * chunkZ;
        n.x = showIndex === showLength - 1 ? 0 : x;
        n.y = showIndex === showLength - 1 ? 0 : y;
        n.z = z;
        showIndex += 1;
      });
      startZ += chunkZ;
    });
  };

  const loadTextures = async () => {
    return new Promise((resolve, reject) => {
      const sheets = range(Math.ceil(shows.length / IMAGES_PER_SPRITE));

      const loadingManager = new THREE.LoadingManager();
      const textureLoader = new THREE.TextureLoader(loadingManager);

      for (let sheet of sheets) {
        textures[sheet] = textureLoader.load(
          `assets/sprite/spritesheet-${sheet}@2x.jpg`
        );
      }

      let pl = 0;
      loadingManager.onLoad = resolve;
      // loadingManager.onStart = () => {};
      loadingManager.onProgress = (e) => {
        pl += 1;
        // $loaded = pl / sheetCount;
      };
      loadingManager.onError = (e) => {
        console.log(e);
      };
    });
  };

  $: aspect = $viewport.width / $viewport.height;
  $: spreadX = aspect;
  $: spreadY = 1 / aspect;

  onMount(async () => {
    mounted = true;
    group.add(planetGroup);
    await loadTextures();

    let placed = {};
    planets = shows.map((d) => {
      if (!placed[d.level]) placed[d.level] = 0;

      const { count } = categories.find((c) => c.name === d.level);

      const layer = Math.floor(placed[d.level] / 9);

      placed[d.level] += 1;

      const match = spritesheet.find((s) => s.slug === d.slug) || {};
      const { sheet, x, y, w, h } = match;
      return {
        ...d,
        layer,
        x: 0,
        y: 0,
        z: 0,
        percentage: 1,
        sprite: sheet ? +sheet : undefined,
        spriteX: x ? +x : 0,
        spriteY: y ? +y : 0,
        spriteW: w ? +w : 0,
        spriteH: h ? +h : 0,
        texture: sheet ? textures[+sheet] : textures[0],
      };
    });
    layout();

    $mode = "loaded";
  });
</script>

{#if mounted}
  {#each planets as planet}
    <Planet planetGroup="{planetGroup}" data="{planet}" />
  {/each}
{/if}
